import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { RegionHintData } from '@Types/Region';
import type { Query } from '@Types/Base';

export interface Result {
  ok: boolean;
  data: RegionHintData[];
}

async function getAllRegions(request: Query): Promise<RegionHintData[]> {
  const url = `/backend/data/regions`;
  const res = await Api.queryProxi<Result>(url, {}, request);

  if (!res.ok) throw new BackendError(url, res);

  return res.data;
}

export default getAllRegions;
